import { useSMID } from '@hc-frontend/core-ui';

export default function UnstyledSMID() {
  const smid = useSMID();

  if (smid) {
    return <div className="[all: inherit]">{smid}</div>;
  }
}
